import React, { PureComponent, Fragment } from 'react';
import { withRouter } from "react-router-dom";

import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, Collapse, Modal, ButtonToolbar } from 'reactstrap';

import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import moment from "moment";
import CheckedIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon';
import ActiveIcon from 'mdi-react/CheckDecagramIcon';
import ComingIcon from 'mdi-react/AlertDecagramOutlineIcon';
import VettedIcon from 'mdi-react/AlertDecagramOutlineIcon';
import CondoDecIcon from 'mdi-react/AlphaCCircleOutlineIcon';
import DocIcon from 'mdi-react/FileDownloadOutlineIcon';
import ContactIcon from 'mdi-react/EmailOutlineIcon';
import MoveIcon from 'mdi-react/AlphaTCircleOutlineIcon';
import ConstructIcon from 'mdi-react/WrenchOutlineIcon';
import ClosingIcon from 'mdi-react/CurrencyUsdCircleOutlineIcon';
import OfferingStatus from './OfferingStatus';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

import{
	_capitalizeText,
	buildingStageToolTips,
	BuildingStageBadge
} from '../helpers/utils';

const apiRoot = process.env.API_ROOT;


class BuildingIcons extends PureComponent {
	
  constructor(props) {
    super(props);
    this.state = {
      modal:false
    };
   
  }
  
  componentDidMount() {	  
	
	
  }
  
  componentDidUpdate(prevProps, prevState, snapshot){

		 
	 
  }

  toggle = (e) => {
	  
	  e.preventDefault();
	  e.stopPropagation();
	  this.setState({modal:!this.state.modal});
  }
 

  render(){
	  const { modal } = this.state;
	  const { building, user, isUnit} = this.props;
	  let hasContact = false;
                      
      if(building.sales_office_details && building.sales_office_details.length > 2){
          try{
              const contactData = JSON.parse(building.sales_office_details);
              if(contactData && contactData.email && contactData.email.indexOf('@')>=0){
                  hasContact = true;
              }
              
          }catch(e){
              
          }
      }
      const iconColor = '#BF96D9';
      
      let isAdmin = user.role && Array.isArray(user.role) && user.role.indexOf('admin')>=0;
      
      if(isMobile) return null;
	  return (
		   <span className="building_icons">
		   		{(!isUnit && (building.building_status || building.ownership_type)) &&
			   		<BuildingStageBadge item={building} small />
            	 }
            	 <OfferingStatus building={building} />
		  </span>
	  )
	}
};
export default connect(state => ({
  user: state.user,
}))(withRouter(BuildingIcons));

